// extracted by mini-css-extract-plugin
export default {"text":"welcome_text__FeXbM","content":"welcome_content__NhJob","all":"welcome_all__NGFin","img":"welcome_img__Ju21N","navbar":"welcome_navbar__GVQ5K"};